/** @format */
// 各个产品线对应name
export const ChildTypeNameMap = {
  '1': 'ks3',
  '4': 'eipdefault',
  '6': 'kcsdefault',
  '2': 'krdsdefault',
  '3': 'ktsdefault',
  '0': 'kvmdefault',
  '12': 'kaddefault',
  '13': 'mongodbdefault',
  '10': 'natdefault',
  '15': 'epcdefault',
  '11': 'sgwdefault',
  '21': 'gpudefault',
  '16': 'peeringdefault',
  '20': 'dedicatedhostdefault',
  '22': 'cdndefault',
  '24': 'listenerhttp',
  '25': 'listenertcp',
  '26': 'listenerhttps',
  '27': 'listenerudp',
  '7': 'lbdefault',
  '17': 'dcgwdefault',
  '28': 'kcecluster',
  '29': 'kcepod',
  '30': 'kcecontainer',
  '38': 'memcached',
  '39': 'drdsdefault',
  '42': 'postgresql',
  '43': 'epcgpu',
  '44': 'sqlserver',
  '46': 'kdts',
  '48': 'KAD-instance',
  '49': 'KAD-Domain',
  '51': 'MongoCluster-Mongos',
  '53': 'MongoCluster-ShardNode',
  '57': 'MongoRepSet-Node',
  '61': 'InfluxDB',
  '67': 'RABBITMQ-INSTANCE',
  '68': 'RABBITMQ-NODE',
  '72': 'KES',
  '73': 'KES-CLUSTER',
  '75': 'KES-NODE',
  '78': 'vGPU',
  '79': 'KingDB',
  '80': 'waf',
  '81': 'waf-instance',
  '82': 'waf-Domain',
  '69': 'KCI',
  '70': 'KCI-POD',
  '71': 'KCI-CONTAINER',
  '83': 'KHBase',
  '84': 'KHBase-Cluster',
  '85': 'KHBase-MasterNode',
  '86': 'KHBase-RegionServerNode',
  '150': 'ks3-accelerate',
  '94': 'KPFS',
  '95': 'ClickHouse',
  '96': 'TiDB',
  '97': 'RedisSdn-Console',
  '98': 'RedisSdn-Node-Console',
  '99': 'RedisCluster-Console',
  '100': 'RedisCluster-Data-Console',
  '101': 'RedisCluster-Proxy-Console',
  '103': 'RedisCluster-Proxy-Overview-Console',
  '104': 'KMRCluster',
  '105': 'kmrnode',
  '106': 'Cassandra',
  '109': 'Cassandra',
  '111': 'kistunneldefault',
  '112': 'kisvpcdefault',
  '113': 'kisportdefault',
  '107': 'WAF3-DOMAIN',
  '114': 'WAF3-INSTANCE',
  '116': 'krdsproxydefault',
  '119': 'krdsproxy',
  '120': 'tidbdefault',
  '121': 'tikvdefault',
  '122': 'tiflashdefault',
  '123': 'pddefault',
  '124': 'ticdcdefault',
  '125': 'kisinternetaccessdefault',
  '126': 'cendefault',
  '18': 'vpntundefault',
  '132': 'milvusdefault',
  '129': 'drdsnodedefault',
  '133': 'starrocksdefault'
}
